<!-- eslint-disable -->
<script setup>
import { onMounted, ref } from 'vue';
import { useRegionsStore } from '@/stores/regions';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useCouponsStore } from '@/stores/coupons';

const regionsStore = useRegionsStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

// Function to change category using camelCase
const selectRegion = (region) => {
	dateTimeSportFiltersStore.visible_region = region;
};

const isCompetitionChecked = (region_id, competition) => {

	let selected_region_id = region_id == -1 ? competition.region_id : region_id;

	const found_region = dateTimeSportFiltersStore.selected_regions.find(r => r.region_id === selected_region_id);
	return found_region ? found_region.competition_ids.includes(competition.id) : false;
};

const handleCompetitionToggle = (region_id, competition, event) => {
	const is_checked = event.target.checked;

	useCouponsStore().toggleCheckboxCompetition(competition.id);
	let selected_region_id = region_id == -1 ? competition.region_id : region_id;
	dateTimeSportFiltersStore.updateSelectedRegion(selected_region_id, competition.id, is_checked);
};

const getSelectedCount = (region_id) => {
	const region = dateTimeSportFiltersStore.selected_regions.find(
		(r) => r.region_id === region_id
	);
	return region ? region.competition_ids.length : 0;
};

onMounted(() => {
	dateTimeSportFiltersStore.visible_region = regionsStore.regionsCompetitionsCoupons[0];
})
</script>

<template>
	<div class="competition-filter-container">
		<div class="categories-sidebar">
			<div v-for="region in regionsStore.regionsCompetitionsCoupons" :key="region.id" :class="['category-item', { 'active': dateTimeSportFiltersStore.visible_region?.id === region.id }]" @click="selectRegion(region)">

				<div class="category-info">
					<div class="country-flag">
						<img :src="'/assets' + region.icon" alt="flag-country">
					</div>
					<span v-if="region.id !=-1" class="category-name">{{ region.name }}</span>
					<span v-else class="category-name">{{ $t('general.top_leagues') }}</span>
				</div>

				<div class="category-counts">
					<div v-if="getSelectedCount(region.id) > 0" class="indicator mini">
						{{ getSelectedCount(region.id) }}
					</div>
					<span class="total-count">({{ region.fixtures_count }})</span>
				</div>
			</div>
		</div>

		<div class="competitions-list">
			<template v-if="dateTimeSportFiltersStore.visible_region">
				<div v-for="competition in dateTimeSportFiltersStore.visible_region.competitions" :key="competition.id" class="competition-row">

					<label class="checkbox-container">
						<input type="checkbox"
							:checked="isCompetitionChecked(dateTimeSportFiltersStore.visible_region.id, competition)"
							@change="handleCompetitionToggle(dateTimeSportFiltersStore.visible_region.id, competition, $event)">
						<span class="checkmark"></span>
						<span class="comp-name">{{ competition.name }}</span>
					</label>

					<span class="comp-count">
						({{ competition.fixtures_count }})
					</span>
				</div>
			</template>
		</div>
	</div>
</template>

<style scoped>
.competition-filter-container {
	display: flex;
	height: 100%;
	background-color: var(--dark);
}

/* Sidebar Styles */
.categories-sidebar {
	flex: 1;
	border-right: 1px solid var(--tab-gray);
	overflow-y: auto;
}

.category-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 10px;
	cursor: pointer;
	transition: background 0.2s;
}

.category-item.active {
	background-color: var(--light-dark); /* Slightly lighter highlight */
}

.category-info {
	display: flex;
	align-items: center;
	gap: 8px;
}

.category-name {
	font-size: 13px;
	color: var(--white);
}

.category-item.active .category-name {
	color: var(--primary); /* Green text for active category */
}

.category-counts {
	display: flex;
	align-items: center;
	gap: 4px;
}

.total-count {
	font-size: 11px;
	color: var(--white);
}

/* Right List Styles */
.competitions-list {
	flex: 1.2;
	overflow-y: auto;
	padding: 10px 0;
}

.competition-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 15px;
}

.checkbox-container {
	display: flex;
	align-items: center;
	position: relative;
	padding-left: 28px;
	cursor: pointer;
	font-size: 13px;
	user-select: none;
	color: var(--white);
}

.checkbox-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.checkmark {
	position: absolute;
	left: 0;
	height: 18px;
	width: 18px;
	background-color: transparent;
	border: 1px solid var(--input-gray);
	border-radius: 3px;
}

.checkbox-container input:checked ~ .checkmark {
	background-color: var(--primary);
	border-color: var(--primary);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
	left: 6px;
	top: 2px;
	width: 5px;
	height: 10px;
	border: solid var(--white);
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
}

.checkbox-container input:checked ~ .checkmark:after {
	display: block;
}

.comp-count {
	font-size: 11px;
	color: var(--white);
}

.comp-count.has-selected {
	color: var(--primary);
}

/* Mini indicator for the sidebar */
.indicator.mini {
	width: 16px;
	height: 16px;
	font-size: 9px;
	background-color: var(--primary);
	display: flex;
	align-content: center;
	justify-content: center;
	align-items: center;
	color: var(--white);
	border-radius: 50%;
	font-weight: bold;
}

.country-flag {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
}

.country-flag img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	display: block;
}
</style>